<template>
  <div>
    <h2>测试动态表单</h2>
    <el-form
      :model="fieldObj"
      ref="ruleForm"
      label-width="180px"
      class="demo-ruleForm"
    >
      <template v-for="(item, index) of fieldArray">
        <template v-if="item.HtmlElements === '输入框'">
          <el-form-item
            :label="item.ShowName"
            :prop="item.ShowName"
            :key="index"
            :rules="
              item.IsRequired
                ? [
                    {
                      required: true,
                      message: '请输入' + item.ShowName,
                      trigger: 'blur',
                    },
                  ]
                : []
            "
          >
            <el-input
              v-model="fieldObj[item.ShowName]"
              :max="item.FieldLength"
              :placeholder="item.Desc"
              show-word-limit
            ></el-input>
          </el-form-item>
        </template>
        <template v-if="item.HtmlElements === '文本域'">
          <el-form-item
            :label="item.ShowName"
            :prop="item.ShowName"
            :key="index"
            :rules="
              item.IsRequired
                ? [
                    {
                      required: true,
                      message: '请输入' + item.ShowName,
                      trigger: 'blur',
                    },
                  ]
                : []
            "
          >
            <el-input
              type="textarea"
              rows="4"
              :placeholder="item.Desc"
              v-model="fieldObj[item.ShowName]"
              :maxlength="item.FieldLength"
              show-word-limit
            ></el-input>
          </el-form-item>
        </template>
        <template v-if="item.HtmlElements === '日历控件'">
          <el-form-item
            :prop="item.ShowName"
            :label="item.ShowName"
            :key="index"
            :rules="
              item.IsRequired
                ? [
                    {
                      required: true,
                      message: '请选择' + item.ShowName,
                      trigger: 'blur',
                    },
                  ]
                : []
            "
          >
            <el-date-picker
              v-model="fieldObj[item.ShowName]"
              :name="item.ShowName"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :placeholder="item.Desc"
            ></el-date-picker>
          </el-form-item>
        </template>
        <template v-if="item.HtmlElements === '下拉框'">
          <el-form-item
            :label="item.ShowName"
            :prop="item.ShowName"
            :key="index"
            :rules="
              item.IsRequired
                ? [
                    {
                      required: true,
                      message: '请选择' + item.ShowName,
                      trigger: 'blur',
                    },
                  ]
                : []
            "
          >
            <el-select
              v-model="fieldObj[item.ShowName]"
              :placeholder="item.Describe"
            >
              <el-option
                v-for="items in item.ElementData"
                :key="items.name"
                :label="items.name"
                :value="items.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="item.HtmlElements === '单选框'">
          <el-form-item
            :label="item.ShowName"
            :key="index"
            :prop="item.ShowName"
            :rules="
              item.IsRequired
                ? [
                    {
                      required: true,
                      message: '请选择' + item.ShowName,
                      trigger: 'blur',
                    },
                  ]
                : []
            "
          >
            <template v-for="(child, index) in item.ElementData">
              <el-radio
                v-model="fieldObj[item.ShowName]"
                :label="child.value"
                :key="index"
                >{{ child.name }}</el-radio
              >
            </template>
          </el-form-item>
        </template>
        <template v-if="item.HtmlElements === '复选框'">
          <el-form-item
            :label="item.ShowName"
            :prop="item.ShowName"
            :key="index"
            :rules="
              item.IsRequired
                ? [
                    {
                      required: true,
                      message: '请选择' + item.ShowName,
                      trigger: 'blur',
                    },
                  ]
                : []
            "
          >
            <el-checkbox-group v-model="fieldObj[item.ShowName]">
              <el-checkbox
                v-for="(child, index) in item.ElementData"
                :label="child.name"
                :key="index"
                >{{ child.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </template>
      </template>
      <div class="text-align">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >立即创建</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'Test',
  data() {
    return {
      fieldArray: [
        {
          ShowName: '姓名',
          ShowValue: null,
          HtmlElements: '输入框',
          FieldLength: 10,
          IsRequired: true,
          Desc: '请输入姓名',
        },
        {
          ShowName: '描述',
          ShowValue: null,
          HtmlElements: '文本域',
          FieldLength: 99,
          IsRequired: true,
          Desc: '请输入描述',
        },
        {
          ShowName: '爱好',
          ShowValue: null,
          HtmlElements: '复选框',
          IsRequired: true,
          Desc: '请选择爱好',
          ElementData: [
            // 爱好
            {
              name: '吃饭',
              value: '吃饭',
            },
            {
              name: '玩游戏',
              value: '玩游戏',
            },
            {
              name: '打豆豆',
              value: '打豆豆',
            },
          ],
        },
        {
          ShowName: '性别',
          ShowValue: null,
          HtmlElements: '单选框',
          IsRequired: true,
          ElementData: [
            {
              // 性别
              name: '男',
              value: 'male',
            },
            {
              name: '女',
              value: 'female',
            },
          ],
        },
        {
          ShowName: '出生日期',
          ShowValue: null,
          HtmlElements: '日历控件',
          IsRequired: true,
          Desc: '请选择出生日期',
        },
        {
          ShowName: '结婚时间',
          ShowValue: null,
          HtmlElements: '日历控件',
          IsRequired: true,
          Desc: '请选择结婚时间',
        },
        {
          ShowName: '职业',
          ShowValue: null,
          HtmlElements: '下拉框',
          IsRequired: true,
          Desc: '请选择职业',
          ElementData: [
            {
              // 职业
              name: '医生',
              value: 'doctor',
            },
            {
              name: '老师',
              value: 'teacher',
            },
            {
              name: '司机',
              value: 'driver',
            },
          ],
        },
      ], // 表单字段集合
      fieldObj: {},
    }
  },
  mounted() {
    this.getFieldData()
  },
  methods: {
    getFieldData() {
      for (let i = 0; i < this.fieldArray.length; i++) {
        let item = this.fieldArray[i]
        if (item.HtmlElements === '复选框') {
          this.$set(this.fieldObj, item.ShowName, [])
        } else if (item.HtmlElements === '日历控件') {
          this.$set(this.fieldObj, item.ShowName, item.ShowValue)
        } else if (item.HtmlElements == '下拉框') {
          this.$set(this.fieldObj, item.ShowName, item.ShowValue)
        } else {
          this.$set(this.fieldObj, item.ShowName, item.ShowValue)
        }
      }
    },
    submitForm(formName) {
      // 提交验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('提交数据')
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      // 重置表单
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style scoped></style>
